import React from 'react';
import { Section } from './ui/Section';
export function BonusIntroSection() {
  return <Section className="px-6 md:px-12 max-w-3xl mx-auto border-t border-[#d4a853]/10" data-id="element-63">
      <div className="text-center space-y-8" data-id="element-64">
        <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#f0c674]" data-id="element-65">
          "Pero eso no es todo."
        </h2>

        <p className="font-serif text-xl md:text-2xl text-gray-300 italic" data-id="element-66">
          Porque un sistema sin soporte es como un auto sin ruedas.
        </p>

        <div className="pt-8 space-y-6 text-lg text-gray-400 font-sans leading-relaxed text-left" data-id="element-67">
          <p data-id="element-68">
            Cuando tomé la decisión de armar este programa, me hice una sola
            pregunta:
          </p>

          <div className="pl-6 border-l-2 border-[#d4a853]/30 space-y-4 py-2" data-id="element-69">
            <p className="font-medium text-gray-200" data-id="element-70">
              ¿Qué necesita alguien para que esto funcione de verdad?
            </p>
            <p data-id="element-71">No qué suena bien en una página de ventas.</p>
            <p data-id="element-72">No qué se ve atractivo en un mockup.</p>
            <p data-id="element-73">
              Qué necesita en el mundo real, el lunes a las 8am, cuando tiene
              que arrancar.
            </p>
          </div>

          <p data-id="element-74">Y la respuesta fue clara:</p>

          <ul className="space-y-4" data-id="element-75">
            <li className="flex items-start" data-id="element-76">
              <span className="text-[#d4a853] mr-3 mt-1" data-id="element-77">→</span>
              <span data-id="element-78">Necesita saber por dónde empezar (sin paralizarse).</span>
            </li>
            <li className="flex items-start" data-id="element-79">
              <span className="text-[#d4a853] mr-3 mt-1" data-id="element-80">→</span>
              <span data-id="element-81">
                Necesita responder sin perder tiempo ni clientes en el camino.
              </span>
            </li>
            <li className="flex items-start" data-id="element-82">
              <span className="text-[#d4a853] mr-3 mt-1" data-id="element-83">→</span>
              <span data-id="element-84">
                Y necesita entregar sin caos mientras el sistema se instala.
              </span>
            </li>
          </ul>

          <p className="pt-4" data-id="element-85">Por eso agregué estos tres bonos.</p>

          <div className="p-6 bg-[#111827]/50 border border-[#b8860b]/20 text-center mt-8" data-id="element-86">
            <p className="font-serif text-xl text-[#f0c674]" data-id="element-87">
              Son gratuitos. Son parte del programa. Y probablemente son lo que
              más vas a usar la primera semana.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}